import {
  useAccount,
  useGetRejectByAccountQuery,
  useGetRejectQuery,
} from "@apis/accounts/useAccounts"
import type {
  IAccountReject,
  IMarket,
  IRejectAccountResponse,
} from "@apis/accounts/types"
import {
  useGetRejectStatusQuery,
  useGetDefaultDispositionsQuery,
  useGetResubmitDispositionsQuery,
} from "@apis/shared/useShared"
import { type IValueLabel } from "@apis/shared/types"

type TRejectInformationData = {
  last_name: string | undefined
  market_code: string | undefined
  market: IMarket | undefined
  rejected_account_data: IAccountReject | undefined
  rejected_data: IRejectAccountResponse | undefined
  reject_statuses: IValueLabel[] | undefined
  default_dispositions: IValueLabel[] | undefined
  resubmit_dispositions: IValueLabel[] | undefined
}

export const useRejectInformationSerializer = (account_id: string) => {
  const getAccountQuery = useAccount(account_id)
  const getRejectByAccountId = useGetRejectByAccountQuery(account_id)
  const getRejectById = useGetRejectQuery({
    account_id,
    reject_id: getRejectByAccountId?.data?.reject_id,
  })
  const getRejectStatusQuery = useGetRejectStatusQuery()
  const getDefaultDispositionsQuery = useGetDefaultDispositionsQuery()
  const getResubmitDispositionsQuery = useGetResubmitDispositionsQuery()

  const data: TRejectInformationData = {
    last_name: getAccountQuery.data?.last_name,
    market_code: getAccountQuery.data?.market_code,
    market: getAccountQuery.data?.market,
    rejected_account_data: getRejectByAccountId.data,
    rejected_data: getRejectById.data,
    reject_statuses: getRejectStatusQuery.data,
    default_dispositions: getDefaultDispositionsQuery.data,
    resubmit_dispositions: getResubmitDispositionsQuery.data,
  }

  const isPending =
    getAccountQuery.isPending ||
    getRejectByAccountId.isPending ||
    getRejectById.isPending ||
    getRejectStatusQuery.isPending ||
    getDefaultDispositionsQuery.isPending ||
    getResubmitDispositionsQuery.isPending

  const isError =
    getAccountQuery.isError ||
    getRejectByAccountId.isError ||
    getRejectById.isError ||
    getRejectStatusQuery.isError ||
    getDefaultDispositionsQuery.isError ||
    getResubmitDispositionsQuery.isError

  return {
    data,
    isPending,
    isError,
  }
}
